import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BaseHistoriales from './BaseHistoriales.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import * as DataGeo from '../data/DataGeo.js';

const BaseHistorialesArgentina = (props) => {
  const [searchParams] = useSearchParams();
  const idPais = searchParams.get('pais');
  const [pais, setPais] = React.useState(null);

  useEffect(() => {
    DataGeo.GetPais(idPais).then(setPais);
  }, [idPais]);

  return <BaseHistoriales tipo={TipoEquipo.SELECCION} competidor={pais} />;
};

export default BaseHistorialesArgentina;
